import { createApp } from "vue";
import HeaderNavigation from "~/src/js/components/HeaderNavigation.vue";
import CommonHeader from "~/src/js/components/CommonHeader.vue";
import CommonFooter from "~/src/js/components/CommonFooter.vue";

globalThis.__VUE_OPTIONS_API__ = true;
globalThis.__VUE_PROD_DEVTOOLS__ = false;

const app = createApp({
});

app
  .component('header-navigation', HeaderNavigation)
  .component('common-header', CommonHeader)
  .component('common-footer', CommonFooter)
  .mount("#app");
